const Quote = ({list}) => {
  const normalizedData = {
    list
  }

  return normalizedData
}

export default Quote
